import React from "react";
import CellPlaceholder from '@app/component/placeholder/CellPlaceholder';


const TableNotHeaderPlaceholder = React.memo(()=> {
    return <div
        className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none bg-white p-4 rounded-xl">
        <div className="animate-pulse">
            <div className="flow-root">
                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full align-middle">
                        <table className="min-w-full divide-y divide-gray-300 text-gray-500">
                            <tbody className="divide-y divide-gray-200 bg-white align-top">
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
                            <tr>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                                <CellPlaceholder/>
                            </tr>
														<tr>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
														</tr>
														<tr>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
														</tr>
														<tr>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
														</tr>
														<tr>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
															<CellPlaceholder/>
														</tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
})

export default TableNotHeaderPlaceholder;